import FullPageLoader from 'components/common/FullPageLoader';
import LiveClock from 'components/common/LiveClock';
import AddGropus from 'components/permissionGroup/AddGroup';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { PermissionSelector } from 'slices/permissionGroupSlice';
import { fetchSinglePermission } from 'slices/permissionGroupSlice';
import { fetchPermissionGroupList } from 'slices/permissionGroupSlice';
import { templatesSelector } from 'slices/templateSlice';
import { fetchTemplatesListPage } from 'slices/templateSlice';

const UpdateGroup = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { singleData, loader, error } = useSelector(PermissionSelector);
    const { id } = useParams();

    useEffect(() => {
            if (id) {
                dispatch(fetchSinglePermission(id));
            }
        }, [dispatch, id]);
    
        if (!singleData) return <div>No interpreter found</div>;
    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className="main_heading">Update Permission Group</h2>
                </div>
            </div>

            <AddGropus item={singleData} loader={loader}/>
        </div>
    );
};

export default UpdateGroup;
